import { Component } from '@angular/core';

@Component({
    selector: 'app-comanage-subnav',
    templateUrl: './comanage-subnav.component.html',
    styleUrls: ['./comanage-subnav.component.scss'],
})
export class ComanageSubnavComponent {}
